import {getEventId, hasCouponDiscount, isTicketed} from '@wix/wix-events-commons-statics'
import {connect} from '../../runtime-context/context'
import {isCouponsAccepted} from '../../../selectors/checkout-options'
import {getInvoice, getInvoiceError, isValidating} from '../../../selectors/invoice'
import {isOrderCompleted} from '../../../selectors/placed-order'
import {getReservationId} from '../../../selectors/reservation'
import {getSortedSelectedTickets} from '../../../selectors/selected-tickets'
import {isFixedPriceTicketSelected} from '../../../selectors/tickets'
import {DetailsPageAppProps} from '../../app/interfaces'
import {isShowCouponInputInPaymentStepEnabled} from '../../../../../../commons/selectors/experiments'
import {CouponInput as Presentation} from './coupon-input'
import {CouponInputRuntimeProps} from './interfaces'

const mapRuntime = ({state, actions: {applyCoupon, resetCouponCode}}: DetailsPageAppProps): CouponInputRuntimeProps => {
  const placedOrder = state.placedOrder.order
  const event = state.event
  const showCoupontInputInPaymentStepEnabled = isShowCouponInputInPaymentStepEnabled(state)
  const shouldShowCouponInputInPaymentStep =
    showCoupontInputInPaymentStepEnabled || !isOrderCompleted(placedOrder) || hasCouponDiscount(getInvoice(state))

  return {
    eventId: getEventId(event),
    error: getInvoiceError(state),
    reservationId: getReservationId(state),
    discountValid: hasCouponDiscount(getInvoice(state)),
    orderCompleted: isOrderCompleted(placedOrder),
    showCouponInput:
      isFixedPriceTicketSelected(state.tickets, getSortedSelectedTickets(state)) &&
      isTicketed(event) &&
      shouldShowCouponInputInPaymentStep &&
      isCouponsAccepted(state),
    applyCoupon,
    resetCouponCode,
    validating: isValidating(state),
    showCoupontInputInPaymentStepEnabled,
  }
}

export const CouponInput = connect<{}, CouponInputRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
